export default "__VITE_ASSET__422cd159__"